"use client";

interface CustomTextInputProps {
  label?: string;
  placeHolder?: string;
  type?: string;
  multiline?: boolean;
  rows?: number;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  id?: string;
  value?: string;
}

export const CustomTextInput = ({
  label,
  placeHolder,
  type = "text",
  multiline = false,
  rows = 4,
  onChange,
  disabled = false,
  error,
  helperText,
  id,
  value,
}: CustomTextInputProps) => {
  const baseClasses =
    "bg-white dark:bg-transparent dark:text-white rounded-md w-full outline-none text-[15px] px-[15px] placeholder:text-[#5a5a5a] border " +
    (error ? "border-red-500" : "border-[#dedede]");

  return (
    <div>
      {label && (
        <label htmlFor={id} className={"mb-[0.3rem] block " + (error ? "text-red-500" : "")}>
          {label}
        </label>
      )}

      {multiline ? (
        <textarea
          id={id}
          placeholder={placeHolder || ""}
          onChange={onChange}
          disabled={disabled}
          value={value}
          rows={rows}
          className={`${baseClasses} py-[12px] resize-none`}
        />
      ) : (
        <input
          id={id}
          type={type}
          placeholder={placeHolder || ""}
          onChange={onChange}
          disabled={disabled}
          value={value}
          className={`${baseClasses} h-[55px]`}
        />
      )}

      {error && helperText && <span className="block mt-2 text-sm text-red-500">{helperText}</span>}
    </div>
  );
};
